import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IFilterInvTsReport } from "./Filter";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { ITimesheet, VerifyStatus } from "../../../models/Timesheet";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface IProps {
    open: boolean,
    filters: IFilterInvTsReport,
    login_ID: number,
    toast: any,
}

export const TimsheetsUploaded = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITimesheet>, loading: boolean });
    const dt = useRef<any>(null);
    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        let po_id_Query = "";

        const response = await Fetch("Timesheet/timesheetReport", "GET", null, `filter=${JSON.stringify(props.filters)}&userID=${props.login_ID}`, props.toast);
        if (response) {
            const data: Array<ITimesheet> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const start_Date = (rowData: ITimesheet) => {
        let date;
        if (rowData.start_Date) date = format(new Date(rowData.start_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const fromDate = (rowData: ITimesheet) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: ITimesheet) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const downloadTimeSheet = async (data: ITimesheet) => {
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${baseUrl}${"Timesheet/download"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = data.timeSheet_Path ? data.timeSheet_Path : "timeSheet";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const d_timesheet = (rowData: ITimesheet) => {
        return (<span onClick={() => {
            if (rowData.consultant_ID && rowData.timeSheet_Path) downloadTimeSheet({ pO_ID: rowData.pO_ID, timeSheet_Path: rowData.timeSheet_Path })
            else props.toast.current.show({ severity: 'error', detail: "TimeSheet Not Found.", life: 3000 });
        }} className="cursor-pointer text-cyan-700 underline">Download</span>);
    };

    const rowClass = (data: ITimesheet) => {
        return {
            'bg-green-300 text-black': data.verify_Status === VerifyStatus.Verified,
            'bg-yellow-100 text-black': data.verify_Status === null || data.verify_Status === VerifyStatus.Pending,
            'bg-pink-100 text-black': data.verify_Status === VerifyStatus.UnVerified,
        };
    };

    useEffect(() => {
        if (props.open) {
            loadTableData();
        };
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;
    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "10px" }}
                ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                loading={tableData.loading}
                rowClassName={rowClass}
            >
                <Column field="consultant_Name" header="Name" />
                <Column field="sales" header="Sales Manager" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="client" header="Client" />
                <Column field="end_Client" header="End Client" />
                <Column field="vendor" header="Vendor" />
                {/* <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} />
                <Column field="start_Date" header="Start Date" body={start_Date} /> */}
                <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="start_Date" header="Start Date" body={(rowData: any) => safeFormatDate(rowData.start_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="workHours" header="Hours" />
                <Column header="Show" body={d_timesheet} />
                <Column field="addedBy" header="Added By" />
                <Column field="editedBy" header="Edited By" />
                <Column field="verifiedBy" header="Verified By" />
                <Column field="timeSheet_Status1" header="Status" />
            </DataTable>
        </>
    );
}